import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { motion } from 'framer-motion';
import { Sparkle, ArrowRight, LinkBreak } from '@phosphor-icons/react';
import ChatMessage from '@/components/ChatMessage';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SharePage() {
  const { shareId } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/share/${shareId}`, { headers: { Authorization: '' } });
        setData(res.data);
      } catch { setError(true); }
    })();
  }, [shareId]);

  return (
    <div className="min-h-screen bg-transparent" data-testid="share-page">
      <nav className="sticky top-0 z-40 glass-header border-b border-white/10">
        <div className="max-w-3xl mx-auto px-6 h-14 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-lg bg-lime-500 flex items-center justify-center">
              <Sparkle weight="fill" className="w-4 h-4 text-white" />
            </div>
            <span className="text-lg font-semibold tracking-tight" style={{ fontFamily: 'Clash Display, sans-serif' }}>Lindey</span>
          </Link>
          <Link to="/auth" className="inline-flex items-center gap-1.5 text-sm font-semibold bg-lime-500 hover:bg-lime-600 text-black px-4 py-2 rounded-xl transition-colors" data-testid="share-try-lindey">
            Try Lindey <ArrowRight weight="bold" className="w-3.5 h-3.5" />
          </Link>
        </div>
      </nav>

      <div className="max-w-3xl mx-auto px-6 py-8">
        {error && (
          <div className="text-center py-20" data-testid="share-not-found">
            <LinkBreak className="w-10 h-10 text-white/30 mx-auto mb-3" />
            <p className="text-white/60 font-medium">This shared conversation doesn't exist or was revoked.</p>
          </div>
        )}
        {!error && !data && (
          <div className="flex justify-center py-20">
            <div className="w-5 h-5 border-2 border-white/10 border-t-lime-500 rounded-full animate-spin" />
          </div>
        )}
        {data && (
          <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}>
            <h1 className="text-2xl font-semibold tracking-tight mb-1" style={{ fontFamily: 'Clash Display, sans-serif' }} data-testid="share-title">{data.title}</h1>
            <p className="text-xs text-white/35 mb-8">Shared from Lindey · read-only</p>
            {data.messages.map((m, i) => (
              <ChatMessage key={m.id || i} message={m} />
            ))}
            <div className="mt-10 glass-panel rounded-2xl p-6 text-center">
              <p className="text-sm text-white/60 mb-3">Want answers like this — processed privately on your own device?</p>
              <Link to="/auth" className="inline-flex items-center gap-2 bg-lime-500 hover:bg-lime-600 text-black font-semibold px-6 py-2.5 rounded-xl text-sm transition-colors" data-testid="share-cta">
                Start using Lindey free <ArrowRight weight="bold" className="w-4 h-4" />
              </Link>
            </div>
          </motion.div>
        )}
      </div>
    </div>
  );
}
